import logo from './logo.svg';
import './App.css';
import React from 'react';
import Appbar from '../src/Appbar'
import Box from '@mui/material/Box';
import Sidebar from './Sidebar';
import Dashboard from './Dashboard';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import Vendors, { Vendorsc } from './Vendors/Vendors';
import VendorsList, { VendorsListc } from './Vendors/VendorsList';
import AddFranchise, { AddFranchisec } from './Franchise/AddFranchise';
import FranchiseList, { FranchiseListc } from './Franchise/FranchiseList';
import Customer from './Cutomers/Customer';
import Settings from './Setting/Settings';
import EditVendor, { EditVendorc } from './Vendors/EditVendor'
import { EditFranchisec } from './Franchise/EditFranchise';
import { PendingVendorListc } from './Vendors/PendingVendor/PendingVendorList';
import { PendingVendorDescc } from './Vendors/PendingVendor/PendingVendorDesc';
import Ordders from './Orders/Ordders';
import Login from '../src/Login'
import { AddPropertyc } from './realestate_portal_admin/AddProperty';
import { EditPropertyc } from './realestate_portal_admin/EditProperty';
import { PropertyListc } from './realestate_portal_admin/PropertyList';
import { Addbuildersc } from './realestate_portal_admin/Addbuilders';
import { BuilderListc } from './realestate_portal_admin/BuilderList';
import { Editbuildersc } from './realestate_portal_admin/Editbuilders';
import { Property_leadsc } from './realestate_portal_admin/Property_leads';
import { AddCompanyc } from './job_portal_admin/AddCompany';

import { CompnayListc } from './job_portal_admin/CompnayList';
import { JobListc } from './job_portal_admin/JobList';
import { JobUsersListc } from './job_portal_admin/JobUsersList';
import { JobApplicationListc } from './job_portal_admin/JobApplicationList';




function App() {
  return (
    <Box sx={{backgroundColor:'#f2f2f2',minHeight:'100vh',width:'100%'}}> 
<Appbar/>

  <React.StrictMode>
    <RouterProvider router={createBrowserRouter([


/////////////// admin section //////////


{
  path: "/" ,
  element:<Login/>,
},

    {
      path: "/dashboard" ,
      element:<Dashboard/>,
    },


    ///////// vendor section ///////////

         {
      path: "/Vendors" ,
      element:<Vendorsc/>,
    },

    {
      path: "/VendorsList" ,
      element:<VendorsListc/>,
    },

    {
      path: "/editVendor/:id" ,
      element:<EditVendorc/>,
    },
   

        {
      path: "/pendingVendor" ,
      element:< PendingVendorListc/>,
    },

           {
      path: "/pendingVendorDesc/:id" ,
      element:<PendingVendorDescc/>,
    },
   

   {
      path: "/Franchise" ,
      element:<AddFranchisec/>,
    },
   
       {
      path: "/frenchiseList" ,
      element:<FranchiseListc/>,
      },

           {
      path: "/frenchise/:id" ,
      element:<EditFranchisec/>,
      },
   
         {
      path: "/Customer" ,
      element:<Customer/>,
    },


             {
      path: "/Settings" ,
      element:<Settings/>,
    },

       

             {
      path: "/Orders" ,
      element:<Ordders/>,
    },






///////////////// property portal ////////////

    {
      path: "/addProperty" ,
      element:<AddPropertyc/>,
    },
        {
      path: "/editProperty" ,
      element:<EditPropertyc/>,
    },
         {
      path: "/propertyList" ,
      element:<PropertyListc/>,
    },


         {
      path: "/addBuilder" ,
      element:<Addbuildersc/>,
    },
         {
      path: "/builderList" ,
      element:<BuilderListc/>,
    },

            {
      path: "/editBuilder" ,
      element:<Editbuildersc/>,
    },

                {
      path: "/property_leads" ,
      element:<Property_leadsc/>,
    },


//////////////////// job portal ///////////////////////

     {
      path: "/addCompany" ,
      element:<AddCompanyc/>,
    },
 

   {
      path: "/companyList" ,
      element:<CompnayListc/>,
    },
   {
      path: "/jobList" ,
      element:<JobListc/>,
    },
       {
      path: "/jobuserlist" ,
      element:<JobUsersListc/>,
    },
 {
      path: "/jobApplicationList/:job_id" ,
      element:<JobApplicationListc/>,
    },





    
])} />

</React.StrictMode>
    </Box>
  );
}

export default App;
